import { useDismiss } from '@hotjar/webapp/hooks/useDismiss';

interface GuideCardVisibility {
  isGuideCardVisible: boolean;
  dismissGuideCard: () => void;
}

export const useGuideCardVisibility = (bannerId: string): GuideCardVisibility => {
  const { isDismissed, dismiss } = useDismiss('GUIDE_CARD', bannerId);

  return {
    isGuideCardVisible: !isDismissed,
    dismissGuideCard: dismiss,
  };
};
